import React from "react";
import classes from "./Faq.module.css";
import { ReactComponent as Cube } from "../../../assets/squares-bg 4.svg";
import Accordion from "@mui/material/Accordion";
import { AccordionDetails, AccordionSummary } from "@mui/material";
import { Link } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";

const Faq = () => {
	return (
		<div className={classes.mainContainer}>
			<div className={classes.firstContainer}>
				<div className={classes.titles}>
					<div>
						<h1 className={classes.title}>FAQ</h1>
						<p>Pytjet e shpeshta</p>
					</div>
				</div>
				<Cube />
			</div>
			<div className={classes.secondContainer}>
				<div className={classes.secondContainerFirstDiv}>
					<Accordion>
						<AccordionSummary
							expandIcon={<PlusOutlined />}
							aria-controls="panel1-content"
							id="panel1-header"
						>
							Sa është pesha maksimale e paskos
						</AccordionSummary>
						<AccordionDetails>
							Pesha maksimale e pakos tuaj që mund të
							transportohet është 500kg.
						</AccordionDetails>
					</Accordion>
					<Accordion>
						<AccordionSummary
							expandIcon={<PlusOutlined />}
							aria-controls="panel2-content"
							id="panel2-header"
						>
							Si është procedura për aplikim?
						</AccordionSummary>
						<AccordionDetails>
							Lorem ipsum dolor sit amet, consectetur adipiscing
							elit. Suspendisse malesuada lacus ex, sit amet
							blandit leo lobortis eget.
						</AccordionDetails>
					</Accordion>
					<Accordion>
						<AccordionSummary
							expandIcon={<PlusOutlined />}
							aria-controls="panel3-content"
							id="panel3-header"
						>
							Si është procedura për aplikim?
						</AccordionSummary>
						<AccordionDetails>
							Lorem ipsum dolor sit amet, consectetur adipiscing
							elit. Suspendisse malesuada lacus ex, sit amet
							blandit leo lobortis eget.
						</AccordionDetails>
					</Accordion>
				</div>
				<div className={classes.secondContainerSecondDiv}>
					<p className="text-lg font-bold">Kërko ndihmë</p>
					<p>
						Ju lutemi na kontaktoni për qdo informatë dhe kërkesë në
						lidhje me shërbimet tona. Ne do të mundohemi që të ju
						ndihmojmë përmes stafit tonë për support teknik.
					</p>
					<Link to="/contact" className="text-purple-700">
						Faqja e kontaktit →
					</Link>
				</div>
			</div>
		</div>
	);
};

export default Faq;
